<template>
    <div class="preview-responsive-container website-page cms-website" :style="[websiteStyle, _pageStyle]"
         :class="[`preview-layout-${$store.state.previewMode}`, `menu-anchor-${cmsWebsite.menu.block.anchor}`, {'preview-device-frame': $store.state.previewDeviceFrame}]">
        <slot name="above"/>
        <div class="overflow" :class="{ 'scrollable-content': !isMobileDevice || !isMapPage }">
            <slot></slot>
        </div>
        <slot name="below"/>
    </div>
</template>

<script>
export default {
    name: `preview-responsive-container`,
    computed: {
        websiteStyle() {
            // Kind of hacky way to propagate deep watch of variables
            if (this.$store.state.websiteStyleVersion) {
                return this.cmsWebsite.styleVariables;
            }
            return this.cmsWebsite.styleVariables;
        },
        _pageStyle() {
            if (!this.cmsPage) {
                return ``;
            }

            let style = {};
            if (this.cmsPage.background === `color` && this.cmsPage.backgroundColor) {
                style[`--page-bg`] = this.cmsWebsite.getColor(this.cmsPage.backgroundColor);
                style.background = this.cmsWebsite.getColor(this.cmsPage.backgroundColor);
            } else if (this.cmsPage.background === `image` && this.cmsPage.backgroundImage) {
                style.background = `url("${this.cmsPage.backgroundImage}") no-repeat center center`;
                style.backgroundSize = `cover`;
            }
            if (this.$store.state.zoom !== 100) {
                style.zoom = this.$store.state.zoom / 100;
            }

            // Disable page padding when there is no header
            if (this.cmsPage?.header.active === false) {
                style["--page-padding-left"] = 0;
                style["--page-padding-right"] = 0;
                style["--page-padding-top"] = 0;
                style["--page-padding-bottom"] = 0;
            }

            return style;
        },
        isMapPage() {
            return this.$route.path.startsWith(`/map`);
        },
    }
}
</script>
<style lang="scss">
@import "../assets/style/website/website.scss";

.preview-responsive-container {
    min-height: var(--app-height);
    padding-left: var(--page-padding-left);
    padding-right: var(--page-padding-right);

    &.preview-layout-tablet,
    &.preview-layout-kiosk {
        border-left: 2px dashed #333;
        border-right: 2px dashed #333;
    }

    &.preview-layout-mobile {
        margin: 0 auto;
        width: 400px !important;

        &:not(.preview-device-frame) {
            border-left: 2px dashed #333;
            border-right: 2px dashed #333;
        }

        &.preview-device-frame {
            max-height: calc(100vh - 200px);
            height: 750px;
            --size-x: 15px;
            --size-y: 40px;
            margin-block: calc(var(--size-y) + 5px);

            &::before {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                box-shadow: inset 0 0 0 2px #ddd, 0 0 0 2px #ddd;
                border: var(--size-x) solid #fff;
                border-block-width: var(--size-y);
                border-radius: 30px;
                margin: calc(var(--size-y) * -1) calc(var(--size-x) * -1);
                width: calc(100% + var(--size-x) * 2);
                height: calc(100% + var(--size-y) * 2);
            }

            &::after {
                --size: 25px;
                content: "";
                display: block;
                position: absolute;
                border-radius: 50%;
                width: var(--size);
                height: var(--size);
                background: #fafafa;
                border: 2px solid #ddd;
                bottom: -32px;
                left: calc(50% - var(--size) / 2);
            }
        }
    }

    &.preview-layout-tablet {
        margin: 0 auto;
        width: 800px !important;

        &.preview-device-frame {
            --size-x: 15px;
            --size-y: 20px;
            margin-block: calc(var(--size-y) + 5px);
            max-height: calc(100% - 50px);
            height: 1024px;

            &::before {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                box-shadow: inset 0 0 0 2px #ddd, 0 0 0 2px #ddd;
                border: var(--size-x) solid #fff;
                border-block-width: var(--size-y);
                border-radius: 10px;
                margin: calc(var(--size-y) * -1) calc(var(--size-x) * -1);
                width: calc(100% + var(--size-x) * 2);
                height: calc(100% + var(--size-y) * 2);
            }

            //&::after {
            //    --size: 25px;
            //    content: "";
            //    display: block;
            //    position: absolute;
            //    border-radius: 50%;
            //    width: var(--size);
            //    height: var(--size);
            //    background: #fafafa;
            //    border: 2px solid #ddd;
            //    bottom: -32px;
            //    left: calc(50% - var(--size) / 2);
            //}
        }
    }

    &.preview-layout-kiosk {
        margin: 0 auto;
        width: 1080px !important;

        &.preview-device-frame {
            --size-x: 15px;
            --size-y: 20px;
            margin-block: calc(var(--size-y) + 5px);
            max-height: calc(100% - 50px);
            height: 1920px;

            &::before {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                border: var(--size-x) solid #333;
                border-block-width: var(--size-y);
                border-radius: 8px;
                margin: calc(var(--size-y) * -1) calc(var(--size-x) * -1);
                width: calc(100% + var(--size-x) * 2);
                height: calc(100% + var(--size-y) * 2);
            }
        }
    }

    .scrollable-content {
        overflow: hidden auto;
        height: var(--app-height);
    }

    //&.preview-device-frame {
    //    > .padding-bar.horizontal {
    //        border-top-left-radius: 10px;
    //        border-top-right-radius: 10px;
    //    }
    //    > .scrollable-content {
    //        border-bottom-left-radius: 10px;
    //        border-bottom-right-radius: 10px;
    //    }
    //}
}
</style>


<style lang="scss">
.preview-responsive-container {
    contain: layout;
}
</style>
